//请自行添加语言资源
const carrierDp = {
  addrCode: '地址编码',
  addrName: '地址名称',
  carrierNo: '承运商编号',
  carrierName: '承运商名称',
  region: '区域',
  companyName: '所属机构',
  useCompanyName: '使用机构',
  provinceCode: '省份编号',
  provinceName: '省',
  cityCode: '市编号',
  cityName: '市',
  districtCode: '区编号',
  districtName: '区',
  addr: '详细地址',
  lat: '经度',
  lng: '纬度',
  contactMan: '联系人',
  contactWay: '联系方式',
  createTime: '创建时间',
  creator: '创建者',
  updateTime: '修改时间',
  updater: '修改者',
  msg: {
    addrName: '请输入地址名称',
    region: '请选择区域',
    shipperCode: '请选择所属客户',
    companyCode: '请选择所属机构',
    carrierNo: '请选择承运商编号',
    addr: '请输入详细地址',
  }
};
export default carrierDp



// WEBPACK FOOTER //
// ./src/page/mdm/carrierDp/lang/carrierDp.zh.js